function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6485 0.35155C18.543 0.246607 18.4098 0.173949 18.2645 0.142118C18.1192 0.110287 17.9678 0.120606 17.8282 0.171863L0.640656 6.42186C0.492428 6.47809 0.364812 6.57807 0.274759 6.70855C0.184705 6.83902 0.136475 6.9938 0.136475 7.15233C0.136475 7.31086 0.184705 7.46564 0.274759 7.59612C0.364812 7.72659 0.492428 7.82658 0.640656 7.8828L7.3516 10.5625L12.3047 5.59374L13.4063 6.6953L8.42972 11.6719L11.1172 18.3828C11.1751 18.5282 11.2753 18.6528 11.4049 18.7405C11.5344 18.8283 11.6873 18.8751 11.8438 18.875C12.0017 18.8717 12.1549 18.8207 12.2832 18.7287C12.4115 18.6366 12.5089 18.5079 12.5625 18.3594L18.8125 1.17186C18.8658 1.03364 18.8786 0.883136 18.8496 0.737897C18.8205 0.592657 18.7508 0.458668 18.6485 0.35155Z",
  fill: "#38F4F1"
});

var SvgSend = function SvgSend(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSend, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/send.0091c50c.svg";
export { ForwardRef as ReactComponent };